module.exports = __webpack_public_path__ + "static/media/filter_icon.672af21f.svg";